var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M18,20.4h-0.9c-0.2,0-0.4,0.3-0.4,0.5V24c0,0.2,0.2,0.4,0.4,0.4H18c-0.2,2.9-2.6,5.1-5.5,5.1h-0.2v-1.1 c0-0.2-0.2-0.4-0.4-0.4H8.6c-0.2,0-0.4,0.2-0.4,0.4v1.1H5.7c-0.2,0-0.4,0.2-0.4,0.4v7.6c0,0.2,0.2,0.5,0.4,0.5h2.6v1 c0,0.2,0.2,0.4,0.4,0.4c0,0,0,0,0,0h3.2c0.2,0,0.4-0.2,0.4-0.4l0,0v-1h0.8c7.6,0,13.7-6,13.9-13.6h0.9c0.2,0,0.4-0.2,0.4-0.4v-3.1 c0-0.2-0.2-0.5-0.4-0.5h-0.8c0.3-2.8,2.6-5,5.5-5h0.2v1c0,0.2,0.2,0.5,0.4,0.5h3.2c0.2,0,0.4-0.3,0.4-0.5v-1h2.6 c0.2,0,0.4-0.2,0.4-0.4v0V7.3c0-0.2-0.2-0.4-0.4-0.4l0,0h-2.6v-1c0-0.2-0.2-0.4-0.4-0.4h-3.2c-0.2,0-0.4,0.2-0.4,0.4v1H32 C24.4,6.9,18.3,12.9,18,20.4z M17.5,23.6v-2.3h1.9v2.3H17.5z M9.1,28.9h2.3v1.8H9.1V28.9z M9.1,34.2h2.3V36H9.1V34.2z M9.1,33.3 v-1.8h2.3v1.8H9.1z M11.4,38.5H9.1v-1.7h2.3V38.5z M13,37.2h-0.8v-6.7h0.2c3.4,0,6.1-2.6,6.4-6h7.3C25.9,31.5,20.1,37.2,13,37.2z  M20.2,23.6v-2.3H22v2.3H20.2z M23,23.6v-2.3h1.7v2.3H23z M27.4,21.3v2.3h-1.8v-2.3H27.4z M35.8,16h-2.3v-1.8h2.3V16z M35.8,10.7 h-2.3V8.9h2.3V10.7z M35.8,11.6v1.7h-2.3v-1.7H35.8z M33.5,6.3h2.3v1.8h-2.3V6.3z M32,7.8h0.8v6.7h-0.2c-3.3,0-6.1,2.6-6.4,5.9h-7.3 C19.1,13.4,24.9,7.8,32,7.8z"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 23,
  y: 21.3,
  fill: "#E3E3E3",
  width: 1.8,
  height: 2.3
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 20.2,
  y: 21.3,
  fill: "#E3E3E3",
  width: 1.8,
  height: 2.3
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 25.5,
  y: 21.3,
  fill: "#E3E3E3",
  width: 1.8,
  height: 2.3
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 33.5,
  y: 14.2,
  fill: "#E3E3E3",
  width: 2.3,
  height: 1.8
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 33.5,
  y: 8.9,
  fill: "#E3E3E3",
  width: 2.3,
  height: 1.8
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 33.5,
  y: 11.6,
  fill: "#E3E3E3",
  width: 2.3,
  height: 1.8
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 33.5,
  y: 6.3,
  fill: "#E3E3E3",
  width: 2.3,
  height: 1.8
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M18.9,20.4h7.3c0.3-3.3,3.1-5.9,6.4-5.9h0.2V7.8H32C24.9,7.8,19.1,13.4,18.9,20.4z"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 17.5,
  y: 21.3,
  fill: "#E3E3E3",
  width: 1.8,
  height: 2.3
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M18.9,24.4c-0.3,3.4-3,6-6.4,6h-0.2v6.7h0.8c7.1,0,12.9-5.6,13.1-12.7H18.9z"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 9.1,
  y: 34.2,
  fill: "#E3E3E3",
  width: 2.3,
  height: 1.8
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 9.1,
  y: 31.5,
  fill: "#E3E3E3",
  width: 2.3,
  height: 1.8
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 9.1,
  y: 28.9,
  fill: "#E3E3E3",
  width: 2.3,
  height: 1.8
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 9.1,
  y: 36.8,
  fill: "#E3E3E3",
  width: 2.3,
  height: 1.8
});

function SvgPlumbing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlumbing);
export default __webpack_public_path__ + "static/media/plumbing.af30bef98fc8c8c2f0431d83f78b6e6e.svg";
export { ForwardRef as ReactComponent };